// Shared axios client with Bearer token support + cookie support (dual-mode auth).
// - Stores JWT in localStorage as a primary mechanism (works across ANY deployment topology)
// - Also sends cookies via withCredentials (fallback for same-origin httpOnly cookie flow)
// Backend accepts EITHER: request.cookies[auth_token] OR Authorization: Bearer <token>
import axios from "axios";

const TOKEN_KEY = "subi_auth_token";

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
};
export const clearAuthToken = () => localStorage.removeItem(TOKEN_KEY);

const apiClient = axios.create({ withCredentials: true });

// Attach Bearer token on every request if available
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Clear stored token on 401 so UI can redirect to login cleanly
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken();
    }
    return Promise.reject(error);
  }
);

export default apiClient;
